export default "__VITE_ASSET__DrOVvpzc__"